import { AsyncPipe } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Form } from '@app/shared/form';
import { FormComponent } from '@app/shared/form/components';
import {
	NbAccordionItemComponent,
	NbAccordionModule,
	NbButtonModule,
	NbIconModule
} from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutPageTitleService } from './layout-page-title.service';

@Component({
	selector: 'app-layout-page-title',
	styleUrls: ['./layout-page-title.component.scss'],
	template: `
		@if ((service.title$ | async) !== 'Home') {
			<div class="row">
				<div class="col-sm-12">
					<div class="bg-primary-300 title-bar d-flex">
						<h6 class="ps-4 m-0 text-white">
							<!-- titolo pagina -->
							{{ service.title$ | async | translate }}
						</h6>
						<div class="right-cnt">
							@if (service.requiredFieldsText$ | async) {
								<span class="text-white pe-1 me-3">
									{{ 'LAYOUT.OBLIGATORY' | translate }}</span
								>
							}
							@if (service.hasFilterForm$ | async) {
								<button
									nbButton
									class="border-0 search-btn"
									[class.expanded]="
										filterAccordion?.expanded || false
									"
									size="large"
									(click)="toggleFilterForm()"
								>
									<nb-icon
										icon="search-outline"
										pack="eva"
									></nb-icon>
								</button>
							}
						</div>
					</div>
				</div>
			</div>
		}
		@if (service.filterForm$ | async; as filterForm) {
			<nb-accordion>
				<nb-accordion-item
					#filterAccordion
					[expanded]="service.accordionSearchExpanded$ | async"
				>
					<nb-accordion-item-body>
						<!-- main filter form  -->
						<app-form
							[form]="
								getAsForm(
									filterForm.containerForm.get(
										service.filterFormName
									)
								)
							"
						></app-form>
						<!-- addiontal filters -->
						@if (
							filterForm.containerForm.get(
								service.additionalFilterFormName
							)
						) {
							<div class="row additional-filters py-2 my-3">
								<div class="col-9 d-flex align-items-center">
									<button
										(click)="
											service.toggleAdditionalFilterForm()
										"
										nbButton
										shape="round"
										class="more-filter-btn"
										size="medium"
									>
										<nb-icon
											icon="funnel-outline"
										></nb-icon>
									</button>
									<span class="ms-3">{{
										'LAYOUT.ADDITIONAL_FILTERS' | translate
									}}</span>
								</div>
								<div class="col-3">
									<button
										(click)="
											service.toggleAdditionalFilterForm()
										"
										class="float-end"
										nbButton
										ghost
										shape="round"
										size="large"
									>
										<nb-icon
											[icon]="
												(service.accordionAddtionalFilterExpanded$
												| async)
													? 'arrow-ios-downward-outline'
													: 'arrow-ios-forward-outline'
											"
										></nb-icon>
									</button>
								</div>
								@if (
									service.accordionAddtionalFilterExpanded$
										| async
								) {
									<div class="col-12 mt-4 px-4">
										<app-form
											[form]="
												getAsForm(
													filterForm.containerForm.get(
														service.additionalFilterFormName
													)
												)
											"
										></app-form>
									</div>
								}
							</div>
						}
						<!-- button filter form search -->
						@if (filterForm.customBtnText) {
							<button
								type="submit"
								nbButton
								[disabled]="!filterForm.containerForm.valid"
								class="float-end ms-2"
								status="secondary"
								(click)="search(true)"
								size="medium"
							>
								{{ filterForm.customBtnText | translate }}
							</button>
						}
						<button
							type="submit"
							nbButton
							[disabled]="!filterForm.containerForm.valid"
							class="float-end"
							status="secondary"
							(click)="search()"
							size="medium"
						>
							{{ filterForm.submitBtnText | translate }}
						</button>
						<!-- button filter form reset -->
						<button
							type="button"
							nbButton
							outline
							(click)="reset()"
							class="float-end me-2 bg-white"
							status="primary"
							size="medium"
						>
							{{ 'UTILS.RESET' | translate }}
						</button>
					</nb-accordion-item-body>
				</nb-accordion-item>
			</nb-accordion>
		}
	`,
	standalone: true,
	imports: [
		NbButtonModule,
		NbIconModule,
		NbAccordionModule,
		FormComponent,
		AsyncPipe,
		TranslateModule
	]
})
export class LayoutPageTitleComponent {
	@ViewChild(NbAccordionItemComponent)
	filterAccordion: NbAccordionItemComponent;

	public service = inject(LayoutPageTitleService);

	toggleFilterForm() {
		this.filterAccordion.toggle();
	}

	search(isCustom = false) {
		this.service.searchEmit(isCustom);
		this.toggleFilterForm();
	}

	reset() {
		this.service.resetEmit();
	}

	/**
	 * SF20240715-FIXME
	 * @param fc abstract control from formGroup.get
	 * @returns Form
	 */
	public getAsForm(fc: AbstractControl<any, any>): Form {
		return fc as unknown as Form;
	}
}
